// Auth pages
import Authenticate from './authenticate'
import SignIn from './sign-in'
import SignUp from './sign-up'
import OtpCode from './otp-code'
import Setup2FA from './setup-2fa'
import Lock from './lock'

export default {
  Authenticate,
  SignIn,
  SignUp,
  OtpCode,
  Setup2FA,
  Lock,
}